import * as React from 'react'
import { Col } from 'react-bootstrap'
import StrongColoredText from '../../../../common/StrongColoredText'

const Step1Info: React.FunctionComponent = () => {
	return (
		<Col>
			<StrongColoredText>Step 1:</StrongColoredText> Enter the URLs that you would like to import content from.
			Approved content for Content Native campaigns includes blogs, articles and landing pages that are built with
			content in focus, which can include links to videos, too. Front pages and product pages are allowed for
			Product Native campaigns.
		</Col>
	)
}

export default Step1Info
